<!-- @format -->

<rules-tag>

<h2 class="ui header">利用規約</h2>
<div class="ui hidden divider"></div>
<div class="ui breadcrumb">
  <a href="/croco-desk" class="section">トップページ</a>
  <div class="divider"> / </div>
  <div class="active section">利用規約</div>
</div>
<div class="ui segment basic">
<rules-content-tag></rules-content-tag>
</div>
<script>
  import rulesTag from '@tags/parts/croco-desk-rules.riot';
  export default {
    components: {
      "rules-content-tag": rulesTag
    }
  }
</script>
</rules-tag>
